import { useUserDefaults } from "components/user/hooks";

/**
 * Hook to get the user's unit type preference
 *
 * @returns Unit type: 0 = Hybrid, 1 = SI, 2 = Imperial
 *
 * @example
 * ```tsx
 * function MyComponent() {
 *   const unitType = useUserUnit();
 *   const { getTargetUnit } = useEvaUnitCore();
 *
 *   const targetUnit = getTargetUnit("m", unitType); // Returns "ft" for Imperial
 * }
 * ```
 */
export default function useUserUnit(): number {
  const defaults = useUserDefaults();
  const unitType = defaults?.unitSetting?.unit ?? 0;
  return unitType; // Default to Hybrid
}
